import { render, staticRenderFns } from "./ReserveOrderList.vue?vue&type=template&id=273c83f7&scoped=true"
import script from "./ReserveOrderList.vue?vue&type=script&lang=js"
export * from "./ReserveOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273c83f7",
  null
  
)

export default component.exports